<template>
  <v-container>
    <v-expansion-panel popout light class="futuristic-expansion-panel">
      <v-expansion-panel-content>
        <template slot="header">
          <div>
            <h4 class="earth-color futuristic-title">GLOBAL SEARCH</h4>
            <div class="title-decoration"></div>
          </div>
        </template>
        <template slot="actions">
          <v-icon color="#587e27">$vuetify.icons.expand</v-icon>
        </template>
        <search-tabs></search-tabs>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-card flat class="futuristic-card">
      <v-card-title class="card-header">
        <div>
          <h4 class="earth-color futuristic-title">Booking Alerts</h4>
          <div class="title-decoration"></div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          label="Search"
          single-line
          hide-details
          v-model="search"
          class="futuristic-search"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="columns"
        :items="getInspectedAlerted"
        :search="search"
        :pagination.sync="pagination"
        :disable-initial-sort="true"
        :loading="$loadingTrue"
        class="futuristic-table"
      >
        <v-progress-linear slot="progress" color="#587e27" indeterminate class="futuristic-progress"></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td data-label="Booking Ref" class="futuristic-cell">{{ props.item.booking_ref_code }}</td>
          <td data-label="Vehicle Registration" class="futuristic-cell">{{ props.item.vehicle_registration }}</td>
          <td data-label="Driver Name" class="futuristic-cell">{{ props.item.driver_name }}</td>
          <td data-label="Alert" :class="['futuristic-cell', props.item.booking_color ? 'alert-cell' : '']" :style="props.item.booking_color">{{ props.item.note }}</td>
          <td data-label="Alert Date" class="futuristic-cell">{{ formated_date(props.item.created_at) }}</td>
          <td data-label="Action Taken" :class="['futuristic-cell', props.item.action_taken === 'Yes' ? 'action-taken-yes' : 'action-taken-no']" v-if="props.item.alert == 'true'">{{ props.item.action_taken }}</td>
          <td data-label="Action Taken" class="futuristic-cell" v-else></td>
          <td data-label="Action" class="futuristic-cell">
            <v-btn
              v-if="props.item.alert == 'true'"
              :depressed="true"
              color="#00acc1"
              @click="updateViewAlertUpdate(props.item.note_public_id)"
              class="futuristic-btn action-btn"
            >View/Update</v-btn>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
      <v-container class="button-container">
        <v-layout row wrap>
          <v-flex xs12 sm6 class="button-group">
            <v-btn
              :depressed="true"
              color="#00acc1"
              @click="getMore()"
              :loading="this.$store.state.LoadingStore.loading"
              class="futuristic-btn"
            >GET MORE</v-btn>
            <v-btn
              :depressed="true"
              color="#757575"
              @click="getAllAlerts()"
              :loading="this.$store.state.LoadingStore.loading"
              class="futuristic-btn"
            >GET ALL</v-btn>
          </v-flex>
          <v-flex xs12 sm6 class="button-group">
            <vue-json-to-csv
              :json-data="getInspectedAlertedCSV"
              csv-title="Booking Alerts"
              :labels="{
                booking_ref_code: { title: 'Booking Ref' },
                vehicle_registration: { title: 'Vehicle Registration' },
                driver_name: { title: 'Driver Name' },
                note: { title: 'Gate Entry Details' },
                created_at: { title: 'Alert Date' },
                session_user: { title: 'Alert Raised By' },
                update_notes: { title: 'Action Taken' },
              }"
            >
              <v-btn
                :depressed="true"
                color="#587e27"
                :loading="$loadingTrue"
                class="futuristic-btn"
              >Download Alerts(CSV)</v-btn>
            </vue-json-to-csv>
            <v-btn
              :depressed="true"
              color="#f57c00"
              @click="getUnticketed()"
              :loading="$loadingTrue"
              class="futuristic-btn"
            >VIEW UNTICKETED ALERTS</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import SearchTabs from "./FindBooking";
import VueJsonToCsv from "vue-json-to-csv";
export default {
  components: { SearchTabs, VueJsonToCsv },
  name: "BookingsAlert",
  data() {
    return {
      search: "",
      page: 2,
      update_alert_dialog: false,
      alert_updates: false,
      term: {
        key: "",
      },
      columns: [
        {
          text: "Booking ref",
          value: "booking_ref_code",
        },
        {
          text: "Vehicle Registration",
          value: "vehicle_registration",
        },
        {
          text: "Driver Name",
          value: "driver_name",
        },
        {
          text: "Alert",
          value: "note",
        },
        {
          text: "Alert date",
          value: "created_at",
        },
        {
          text: "Action Taken",
          value: "action_taken",
        },
      ],
      pagination: {
        rowsPerPage: 10
      },
      rowsPerPageItems: [10, 25, { text: 'All', value: -1 }],
    };
  },
  created() {
    this.$store.dispatch("get_inspected_alerted_bookings");
  },
  methods: {
    formated_date(date) {
      if (!date) return '';
      return new Date(date).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    },
    updateViewAlertUpdate: function (note_id) {
      this.$router.push({
        name: "ViewUpdateAlert",
        params: {
          note_id: note_id,
        },
      });
    },
    searchTerm: function () {
      this.$store.dispatch("search_inspect_booking_by_key", this.term);
    },
    getUnticketed: function () {
      this.$router.push({
        name: "BookingUnticketedAlert",
      });
    },
    getMore() {
      this.loading = true;
      let data = {
        page: this.page,
      };
      if (this.page === 2) {
        this.$store.dispatch("get_more_inspected_alerted_bookings", data);
        this.page = this.page + 1;
      } else {
        this.$store.dispatch("get_more_inspected_alerted_bookings", data);
        this.page = this.page + 1;
      }
    },
    getAllAlerts() {
      this.loading = true;
      let data = {
        page: 0,
      };
      this.$store.dispatch("get_more_inspected_alerted_bookings", data);
    },
  },
  computed: {
    getInspectedAlertedCSV: function () {
      let all_notes =
        this.$store.state.BookingStore.inspection_alerted_bookings;
      let notes_arr = [];
      if (all_notes.length > 0) {
        for (let i = 0; i < all_notes.length; i++) {
          let notes_obj = {};
          notes_obj["booking_ref_code"] = all_notes[i].booking_ref_code;
          notes_obj["vehicle_registration"] = all_notes[i].vehicle_registration;
          notes_obj["driver_name"] = all_notes[i].driver_name;
          notes_obj["note"] = all_notes[i].note;
          notes_obj["created_at"] = this.formated_date(all_notes[i].created_at);
          notes_obj["session_user"] = all_notes[i].session_user;
          let updates = all_notes[i].update_notes;
          let updates_arr = [];
          if (updates.length > 0) {
            for (let j = 0; j < updates.length; j++) {
              updates_arr.push(updates[j].alert_update);
            }
          }
          notes_obj["update_notes"] = updates_arr;
          notes_arr.push(notes_obj);
        }
      }
      return notes_arr;
    },
    getInspectedAlerted() {
      const all = this.$store.state.BookingStore.inspection_alerted_bookings;
      if (!all) return [];
      return all;
    },
  },
};
</script>

<style scoped>
/* Futuristic Card */
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

/* Expansion Panel */
.futuristic-expansion-panel {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-expansion-panel:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

/* Card Header */
.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.futuristic-title {
  position: relative;
  display: inline-block;
}

.futuristic-title::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, #587e27, transparent);
  transform: scaleX(0);
  transform-origin: right;
  transition: transform 0.3s ease;
}

.futuristic-title:hover::after {
  transform: scaleX(1);
  transform-origin: left;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

/* Input Fields */
.futuristic-search >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
  border: 1px solid rgba(46, 125, 50, 0.2);
  transition: all 0.3s ease;
}

.futuristic-search >>> .v-input__slot:hover {
  border-color: #587e27;
  box-shadow: 0 0 10px rgba(46, 125, 50, 0.2);
}

.futuristic-search >>> .v-input__slot:focus-within {
  border-color: #587e27;
  box-shadow: 0 0 15px rgba(46, 125, 50, 0.3);
}

.futuristic-select >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
  border: 1px solid rgba(46, 125, 50, 0.2);
  transition: all 0.3s ease;
}

.futuristic-select >>> .v-input__slot:hover {
  border-color: #587e27;
  box-shadow: 0 0 10px rgba(46, 125, 50, 0.2);
}

/* Buttons */
.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
  margin: 8px;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.futuristic-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  transition: left 0.7s ease;
}

.futuristic-btn:hover::before {
  left: 100%;
}

.action-btn {
  background: linear-gradient(135deg, #00acc1 0%, #26c6da 100%) !important;
  color: white !important;
}

/* Data Table */
.futuristic-table {
  border-radius: 8px;
  background: #ffffff;
}

.futuristic-table >>> th {
  color: #587e27;
  font-weight: 600;
  background: linear-gradient(45deg, #e8f5e9 0%, #f1f8e9 100%) !important;
  font-size: 0.9rem;
  padding: 16px 8px;
  border-bottom: 2px solid #587e27;
}

.futuristic-table >>> tr:hover {
  background: rgba(232, 245, 233, 0.3) !important;
}

.futuristic-cell {
  padding: 12px 8px;
  border-bottom: 1px solid rgba(46, 125, 50, 0.1);
  transition: background-color 0.2s ease;
}

.futuristic-cell:hover {
  background: rgba(232, 245, 233, 0.2);
}

.alert-cell {
  font-weight: 600;
}

.action-taken-yes {
  color: #587e27;
  font-weight: 600;
}

.action-taken-no {
  color: #f44336;
  font-weight: 600;
}

/* Progress Bar */
.futuristic-progress {
  height: 3px !important;
  border-radius: 3px;
}

/* Alerts */
.futuristic-alert {
  border-radius: 8px;
  background: #fff5f5;
  border: 1px solid rgba(244, 67, 54, 0.2);
}

/* Button Container */
.button-container {
  padding: 0;
}

.button-group {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin: 16px 0;
  justify-content: center;
}

/* Icons */
.futuristic-icon {
  filter: drop-shadow(0 2px 4px rgba(46, 125, 50, 0.3));
}

/* Responsive Adjustments */
@media (max-width: 960px) {
  .card-header {
    padding: 12px;
  }
  .earth-color {
    font-size: 1.25rem;
  }
  .futuristic-title::after {
    bottom: -3px;
  }
  .title-decoration {
    width: 80px;
    height: 3px;
  }
  .futuristic-search >>> .v-input__slot {
    margin-bottom: 12px;
  }
  .futuristic-btn {
    margin: 6px;
    font-size: 0.9rem;
  }
  .button-group {
    justify-content: center;
  }
  .futuristic-table >>> th {
    padding: 12px 6px;
    font-size: 0.8rem;
  }
  .futuristic-cell {
    padding: 10px 6px;
  }
}

@media (max-width: 600px) {
  .card-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 8px;
  }
  .futuristic-search {
    width: 100%;
    margin-top: 12px;
  }
  .earth-color {
    font-size: 1.1rem;
  }
  .title-decoration {
    width: 60px;
    height: 2px;
  }
  .futuristic-btn {
    width: 100%;
    margin: 4px 0;
    font-size: 0.85rem;
  }
  .button-group {
    flex-direction: column;
    align-items: center;
  }
  .futuristic-table {
    font-size: 0.85rem;
  }
  .futuristic-table >>> th {
    padding: 8px 4px;
    font-size: 0.75rem;
  }
  .futuristic-cell {
    padding: 8px 4px;
  }
  .action-btn {
    width: 100%;
  }
  .futuristic-select {
    margin-top: 8px;
  }
}
</style>